
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/t/[territorySlug]/explore",
      function () {
        return require("private-next-pages/t/[territorySlug]/explore/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/t/[territorySlug]/explore"])
      });
    }
  